// extracted by mini-css-extract-plugin
export var closeButton = "_49-3";
export var header = "_49-0";
export var link = "_49-1";
export var retryButton = "_49-2";